<template>
  <div class="container">
    <van-pull-refresh
      v-model="isLoading"
      success-text="刷新成功"
      :disabled="disabledPull || activityInfo.activityStatus !== 1"
      @refresh="onRefresh"
    >
      <div v-if="!isLive" class="pageNative flex_center">
        <div class="rule float" @click="onShowRule">活动规则</div>
        <div
          v-if="activityInfo.activityStatus === 0"
          class="nativeStatus flex_center"
        >
          活动将于 {{ activityInfo.startTime }} 开始
        </div>
        <div
          v-else
          class="nativeStatus flex_center"
        >
          活动已结束
        </div>
      </div>
      <div v-else class="page">
        <div class="header">
          <div class="role_info">
            <template v-if="hasBinded">
              <div class="d_flex mb_8">
                <div class="role_label color_white">角色名：</div>
                <div class="role_name mr_2 van-ellipsis">{{ activityInfo.roleName }}</div>
                <div class="role_bind" @click="onClickChangeBind">切换角色</div>
              </div>
              <div class="d_flex">
                <div class="role_label color_white">角色id：</div>
                <div class="role_name role_id mr_2 mb_4 van-ellipsis">{{ activityInfo.roleId }}</div>
              </div>
            </template>
            <template v-else>
              <div class="d_flex">
                <div class="role_label color_white">角色信息：</div>
                <div class="role_bind" @click="onClickBind">确认角色</div>
              </div>
            </template>
          </div>
        </div>
        <div class="main">
          <img class="main_img" :src="activityInfo.icon" alt="">
          <div class="rule float" @click="onShowRule">活动规则</div>
          <div
            v-if="hasBinded && activityInfo.issueType === 1"
            class="record float"
            @click="onShowRecord"
          >领取记录</div>
        </div>
        <div class="footer">
          <div
            class="sign_btn fbtn bg_contain"
            :style="{ backgroundImage: `url(${activityInfo.applyIcon})` }"
            @click="onApply"
          />
          <div
            v-if="activityInfo.issueType === 1"
            class="receive_btn fbtn bg_contain"
            :style="{ backgroundImage: `url(${activityInfo.drawIcon})` }"
            @click="onReceive"
          />
        </div>
        <Record ref="recordRef" :activityId="params.activityId" />
      </div>
      <Popup
        :visible.sync="visible"
        v-bind="feedback"
        :skins="{
          headerBg: 'linear-gradient(160deg,#565ade 0%, #658dfd 100%)'
        }"
        :innerTitleStyle="{color: '#658dfd'}"
        confirmButtonColor="#658dfd"
        cancelButtonColor="#00BFD3"
        @confirm="feedback.onSure"
      >
        <template v-if="feedbackType === FEEDTYPE_MAP.RULE">
          <p class="rule_wrap" style="white-space: pre-wrap; text-align: left">{{ activityInfo.rule }}</p>
        </template>
        <template v-if="feedbackType === FEEDTYPE_MAP.CONFIRM">
          <div class="receive_confirm fs_16">
            <div class="mb_16 text_center">您当前累充金额为<span class="highlight">{{ rewardInfo.money }}</span>元，可获得</div>
            <div
              v-for="(g, gi) in rewardInfo.giftNames"
              :key="gi"
              class="text_center mt_8 highlight"
            >{{ g }}</div>
            <div v-if="rewardInfo.needMoney" class="mt_16 text_center">
              再充<span class="highlight">{{ rewardInfo.needMoney }}</span>元，可得{{ rewardInfo.needGiftName }}
            </div>
          </div>
        </template>
        <template v-if="feedbackType === FEEDTYPE_MAP.SUCCESS">
          <div class="receive_success">
            <div v-for="i in welList" :key="i.giftId" class="receive_s_item d_flex">
              <div class="receive_s_item_label bold fs_16 mr_8 van-ellipsis">{{ i.giftName }}</div>
              <div class="receive_s_item_value">
                <div v-if="!i.cdk" class="receive_s_item_error">领取失败，请联系客服</div>
                <div v-else v-clipboard="i.cdk" class="receive_s_item_success">
                  <div class="receive_s_item_cdk">{{ i.cdk }}</div>
                  <div class="receive_s_item_btn">
                    <i class="iconfont yw-copy"></i>复制
                  </div>
                </div>
              </div>
            </div>
            <div class="highlight fs_12 text_center">礼包时间有限，请及时前往游戏中兑换</div>
          </div>
        </template>
      </Popup>
    </van-pull-refresh>
  </div>
</template>

<script>
import { ActivityInfo, FEEDTYPE_MAP } from './config';
import {
  getPromoteActInfo, promoteActivitySignUp,
  receivePromoteReward, getPromoteRewardInfo,
} from '@/apis/activity.api';
import Popup from '@/components/Popup.vue';
import store from "@/store";
import parseQuery from '@/mixins/parseQuery'
import trackingMixin, { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
import Record from './record'

const {
  SUCCESS, INSUFFICIENT_GIFT, SHOW_GIFT, MORE_GAME,
  CONFIRM, RULE, NO_ROLE, CONDITION_NOT_SATISFY,
} = FEEDTYPE_MAP
export default {
  components: {
    Popup,
    Record,
  },
  mixins: [parseQuery, trackingMixin],
  data () {
    return {
      isLoading: false,
      disabledPull: false,
      hasFetched: false,
      activityInfo: new ActivityInfo(),
      visible: false,
      FEEDTYPE_MAP,
      feedbackType: RULE,
      fields: ['activityId'],
      clickLoading: false,
      welList: [] , // 领取奖励礼包列表
      rewardInfo: {}, // 奖励确认时的奖励信息
    }
  },
  computed: {
    isLive () {
      if (!this.hasFetched) return true
      if (!this.activityInfo.activityId) return false
      return [1, 2].includes(this.activityInfo.activityStatus)
    },
    // 活动正常态
    isNormal () {
      return [1].includes(this.activityInfo.activityStatus)
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      return {
        [NO_ROLE]: {
          onSure: () => {},
          onCancel: () => {},
        },
        [RULE]: {
          title: '活动规则',
          showConfirmButton: false,
          showCancelButton: false,
          onSure: () => {},
          onCancel: () => {},
        },
        [CONDITION_NOT_SATISFY]: {
          title: '不满足条件',
          message: ['活动期间累计充值金额未达标'],
          confirmButtonText: '我知道了',
          onSure: () => {
            this.triggerVisible(false)
          },
          onCancel: () => {},
        },
        [CONFIRM]: {
          title: '领取确认',
          confirmButtonText: '领取奖励',
          onSure: () => {
            this.onSureReceive()
          },
        },
        [SUCCESS]: {
          title: '领取成功',
          showConfirmButton: false,
          onSure: () => {
            this.triggerVisible(false)
          },
        }
      }
    },
    hasBinded () {
      return this.activityInfo.roleBind
    },
    trackActInfo () {
      return {
        activity_id: this.params.activityId,
        activity_name: this.activityInfo.name,
        game_id: this.activityInfo.gameId,
        game_name: this.activityInfo.gameName,
        role_id: this.activityInfo.roleId,
      }
    },
  },
  created () {
    this.$nextTick(() => {
      this.getActInfo().then(res => {
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.wechat_promote_page,
          this.trackActInfo,
          { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
        )
      })
    })
  },
  methods: {
    getActInfo () {
      return getPromoteActInfo({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.params.activityId,
      }).then(res => {
        const { name } = res.data
        this.activityInfo = res.data || new ActivityInfo()
        document.title = name
        this.hasFetched = true
      }).catch((err) => {
        const { code } = err
        // 点击频繁
        if (code !== 1032) {
          this.hasFetched = true
        }
      })
    },
    onRefresh () {
      this.getActInfo(false).finally(res => {
        setTimeout(() => {
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.wechat_promote_page,
            this.trackActInfo,
            { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
          )
          this.isLoading = false
        }, 800)
      })
    },
    onClickBind () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_promote_bind_role_button,
        this.trackActInfo,
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      this.$nextTick(() => {
        this.goBindPage()
      })
    },
    onClickChangeBind () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_promote_cut_role_button,
        this.trackActInfo,
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      this.$nextTick(() => {
        this.goBindPage()
      })
    },
    // 跳转绑定
    goBindPage () {
      this.$router.push({
        name: 'promoteBind',
        query: {
          uid: this.activityInfo.uid,
          activityId: this.params.activityId,
          wx_app_id: this.$storeGet('WX_APP_ID'),
        }
      })
    },
    onShowRule () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_promote_button,
        {
          ...this.trackActInfo,
          button_type: 1
        },
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      this.triggerVisible(true, RULE)
    },
    // 打开奖励记录面板
    onShowRecord () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_promote_button,
        {
          ...this.trackActInfo,
          button_type: 2
        },
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      this.$refs.recordRef.triggerVisible(true)
    },
    // 我要报名!
    onApply () {
      if (!this.isNormal) {
        this.$toast('活动已结束')
        return
      }
      if (!this.validBinded()) return
      if (this.clickLoading) return
      this.clickLoading = true
      promoteActivitySignUp({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.params.activityId,
      }).then(res => {
        this.$toast('报名成功，可领取奖励')
        this.getActInfo()
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.wechat_promote_apply_button,
          this.trackActInfo,
          { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
        )
      }).finally(() => {
        this.clickLoading = false
      })
    },
    onReceive () {
      if (!this.isLive) {
        this.$toast('活动已结束')
        return
      }
      if (!this.validBinded()) return
      if (!this.activityInfo.apply) {
        this.$toast('请先报名后领取奖励')
        return
      }
      if (this.clickLoading) return
      this.clickLoading = true
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_promote_draw_button,
        this.trackActInfo,
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      getPromoteRewardInfo({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.params.activityId,
      }).then(res => {
        this.rewardInfo = res.data
        this.triggerVisible(true, CONFIRM)
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.wechat_promote_draw_ack_pop,
          {
            ...this.trackActInfo,
            money: res.data.money,
            reward_id: this.activityInfo.rewardId,
            gift_names: res.data.giftNames,
          },
          { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
        )
      }).catch((err) => {
        const { code, msg } = err
        if (code === 14016) {
          const [a, b, gift] = msg.split('/')
          this.triggerVisible(true, CONDITION_NOT_SATISFY)
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.wechat_promote_draw_not_complete_pop,
            {
              ...this.trackActInfo,
              cur_value: a,
              tar_value: b,
              gift_name: gift,
              rewardId: this.activityInfo.rewardId,
            },
            { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
          )
          return
        }
        this.$toast.fail(msg)
      }).finally(() => {
        setTimeout(() => {
          this.clickLoading = false
        }, 200)
      })
    },
    // 确定领取奖励
    onSureReceive () {
      this.triggerVisible(false)
      if (this.clickLoading) return
      this.clickLoading = true
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_promote_draw_reward_button,
        {
          ...this.trackActInfo,
          money: this.rewardInfo.money,
          reward_id: this.activityInfo.rewardId,
          gift_names: this.rewardInfo.giftNames,
        },
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      receivePromoteReward({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.params.activityId,
      }).then(res => {
        this.welList = res.data || []
        const allFail = this.welList.every(i => !i.cdk)
        setTimeout(() => {
          if (allFail) {
            this.$toast('领取失败，请联系客服')
          } else {
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_promote_draw_success_pop,
              {
                ...this.trackActInfo,
                money: this.rewardInfo.money,
                reward_id: this.activityInfo.rewardId,
                gifts: res.data || [],
              },
              { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
            )
            this.triggerVisible(true, SUCCESS)
          }
        }, 300)
      }).catch((err) => {
        const { code, msg } = err
      }).finally(() => {
        setTimeout(() => {
          this.clickLoading = false
        }, 200)
      })
    },
    // 验证当前是否已绑定
    validBinded () {
      if (!this.hasBinded) {
        this.goBindPage()
        return false
      }
      return true
    },
    triggerVisible (visible, type) {
      if (visible && this.visible) return
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = visible
    },
  },
}
</script>

<style lang="scss" scoped>
.pageNative {
  min-height: 100vh;
  font-size: 16px;
}
.page {
  position: relative;
}
.float {
  position: fixed;
  z-index: 10;
  right: -2px;
  color: #7b0000;
  background-color: #FDC769;
  font-size: 12px;
  border-radius: 100px 0px 0px 100px;
  padding: 5px 8px;
}
.rule {
  top: 12px;
}
.main {
  position: relative;
  min-height: 100vh;
  background-color: #474546;
  .main_img {
    width: 100%;
    user-select: none;
  }
  .record {
    top: 44px
  }
}
.rule_wrap {
  font-size: 14px;
  line-height: 18px;
  word-wrap: break-word;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 6;
  width: 100vw;
  padding: 14px 72px 12px 12px;
  background: #6d6d69b3;
  font-size: 15px;
  color: #fff;
  .role_info {
    .role_name {
      flex: 1;
      width: 0;
      max-width: 140px;
    }
    .role_id {
      max-width: 200px;
    }
    .role_bind {
      color: #00FFE0;
      padding-bottom: 4px;
      border-bottom: 1px solid #00FFE0;
    }
  }
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 6;
  width: 100vw;
  display: flex;
  background-color: #000;
  .fbtn {
    flex: 1;
    height: 60px;
    font-size: 18px;
    color: #fff;
    line-height: 60px;
    text-align: center;
  }
  .receive_btn {
    // background-color: green;
  }
  .sign_btn {
    // background-color: red;
  }
}
.receive_s_item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.receive_s_item_label {
  width: 94px;
  text-align: right;
}
.receive_s_item_value {
  flex: 1;
  .receive_s_item_cdk {
    flex: 1;
    color: #5C5C5C;
  }
  .receive_s_item_success {
    display: flex;
    align-items: center;
    font-size: 15px;
    background-color: #f1f5ff;
    border-radius: 4px;
    padding: 10px 6px 10px 12px;
  }
  .receive_s_item_btn {
    font-size: 12px;
    color: #565ADE; 
    i {
      font-size: 12px;
    }
  }
}
.highlight {
  color: #FE3636;
}
</style>